import { render, staticRenderFns } from "./Pagenation.vue?vue&type=template&id=0c4d4f23&scoped=true"
import script from "./Pagenation.vue?vue&type=script&lang=js"
export * from "./Pagenation.vue?vue&type=script&lang=js"
import style0 from "./Pagenation.vue?vue&type=style&index=0&id=0c4d4f23&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4d4f23",
  null
  
)

export default component.exports